type PageInfo = {
  iframeHeight: number;
  iframeWidth: number;
  clientHeight: number;
  clientWidth: number;
  offsetTop: number;
  offsetLeft: number;
  scrollTop: number;
  scrollLeft: number;
  windowHeight: number;
  windowWidth: number;
};

class IframeResizerUtils {
  pageInfo: PageInfo | null = null;
  isInitialized = false;

  initIfNeeded = () => {
    if (this.isInitialized) return;

    if (this.isInResizedIframe()) {
      try {
        if ((window as any).parentIFrame.getPageInfo(this.updatePageInfo)) {
          this.isInitialized = true;
        }
      } catch (error) {
        console.error('Error initializing iframe resizer', error);
      }
    }
  };

  isInResizedIframe = () => {
    return 'parentIFrame' in window;
  };

  isEmbeddedInIframe = () => {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  };

  updatePageInfo = (pageInfo: PageInfo) => {
    this.pageInfo = pageInfo;
  };

  scrollToTop = () => {
    try {
      if (this.isInResizedIframe() && this.pageInfo) {
        (window as any).parentIFrame.scrollTo(0, this.pageInfo.offsetTop - 60);
      }
    } catch (error) {
      console.error('Error scrolling to top', error);
    }
  };

  // The resized iframe has no scroll of its own: scrollIntoView would scroll the parent page
  // unpredictably, so ask the parent to scroll to the element instead
  scrollToElement = (element: Element): boolean => {
    if (!this.isInResizedIframe()) return false;
    try {
      const top = element.getBoundingClientRect().top + window.scrollY;
      (window as any).parentIFrame.scrollToOffset(0, top - 60);
      return true;
    } catch (error) {
      console.error('Error scrolling to element', error);
      return false;
    }
  };
}

export default new IframeResizerUtils();
